var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTinaco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.718,
    height: 89.718,
    viewBox: "0 0 89.718 89.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_viviendas",
    transform: "translate(-306 -896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6451",
    "data-name": "Rectangle 6451",
    width: 89.718,
    height: 89.718,
    transform: "translate(306 896)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8285",
    "data-name": "Group 8285",
    transform: "translate(183.461 877.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19958",
    "data-name": "Path 19958",
    d: "M187.505,147.52a93.032,93.032,0,0,1-24.652-3.382,8.3,8.3,0,0,1-6.051-8.009V89.939a8.137,8.137,0,0,1,3.649-6.853l13.261-8.9a1.717,1.717,0,0,1,.89-.267h25.809a1.5,1.5,0,0,1,.89.267l13.261,8.9a8.139,8.139,0,0,1,3.649,6.853v46.189a8.3,8.3,0,0,1-6.051,8.009,93.024,93.024,0,0,1-24.654,3.382Zm-12.37-70.4-12.816,8.633a5,5,0,0,0-2.225,4.183v46.189a5.128,5.128,0,0,0,3.738,4.895,87.951,87.951,0,0,0,47.524,0,5.048,5.048,0,0,0,3.738-4.895V89.939a4.887,4.887,0,0,0-2.225-4.183l-12.816-8.633Z",
    transform: "translate(-18.373 -43.331)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19959",
    "data-name": "Path 19959",
    d: "M286.132,42.743H260.324a1.6,1.6,0,0,1-1.6-1.6v-5.7a1.63,1.63,0,0,1,1.424-1.6,107.255,107.255,0,0,1,26.165,0,1.63,1.63,0,0,1,1.424,1.6v5.7a1.6,1.6,0,0,1-1.6,1.6Zm-24.207-3.2h22.516V36.959a105.812,105.812,0,0,0-22.516,0Z",
    transform: "translate(-104.095 -8.95)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19960",
    "data-name": "Path 19960",
    d: "M173.354,157.578h-.178c-2.759-.267-5.518-.534-8.276-.979a1.612,1.612,0,0,1,.356-3.2c2.67.356,5.429.712,8.188.89a1.607,1.607,0,0,1,1.424,1.78,1.5,1.5,0,0,1-1.513,1.513Z",
    transform: "translate(-23.978 -110.169)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19961",
    "data-name": "Path 19961",
    d: "M272.716,159.026c-4.361,0-8.721-.178-13.082-.445a1.6,1.6,0,1,1,.178-3.2,214.287,214.287,0,0,0,40.671-1.424,1.612,1.612,0,0,1,.356,3.2,211.229,211.229,0,0,1-28.123,1.869Z",
    transform: "translate(-103.583 -110.638)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19962",
    "data-name": "Path 19962",
    d: "M284.924,26.05a1.637,1.637,0,0,1-1.6-1.513,1.675,1.675,0,0,1,1.513-1.78c2.047-.178,4-.267,5.874-.356a1.647,1.647,0,1,1,.089,3.293c-1.869.089-3.649.178-5.7.356h-.179Z",
    transform: "translate(-124.78)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19963",
    "data-name": "Path 19963",
    d: "M367,26.05h-.178c-2.047-.178-3.916-.267-5.7-.356a1.647,1.647,0,1,1,.089-3.293c1.869.089,3.826.178,5.874.356a1.744,1.744,0,0,1,1.513,1.78A1.637,1.637,0,0,1,367,26.05Z",
    transform: "translate(-188.875)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19964",
    "data-name": "Path 19964",
    d: "M297.738,260.4a26.972,26.972,0,0,0-4.717-4.717,2.54,2.54,0,0,0-2.937,0l-.089.089a31.884,31.884,0,0,0-4.628,4.628c-3.2,3.916-4.805,8.1-4.805,12.015a10.95,10.95,0,1,0,21.893,0c.089-3.916-1.513-8.01-4.717-12.015Zm1.691,11.925a7.834,7.834,0,1,1-15.664,0c0-3.2,1.424-6.586,4.183-9.967a28.791,28.791,0,0,1,3.738-3.827,30.891,30.891,0,0,1,3.738,3.827c2.581,3.382,4.005,6.853,4.005,9.967Z",
    transform: "translate(-122.464 -195.817)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19965",
    "data-name": "Path 19965",
    d: "M139.319,417.574H136.2a1.216,1.216,0,0,1-1.246-1.246v-5.162a1.217,1.217,0,0,1,1.246-1.246h3.115a1.246,1.246,0,0,1,0,2.492H137.45v2.67h1.869a1.217,1.217,0,0,1,1.246,1.246,1.337,1.337,0,0,1-1.246,1.246Z",
    transform: "translate(0 -325.933)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 0.7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTinaco);
export default __webpack_public_path__ + "static/media/ico_tinaco.de637c9cc1557e4f6ba6ff7e8b4fb192.svg";
export { ForwardRef as ReactComponent };